module.exports = __webpack_public_path__ + "static/media/haircut_important.76ef1abe.svg";